//#region Styles
import {
    Container
} from "./styles";
//#endregion

const FoundBlock = ({
    dataFound, 
    onClick,
    positionFoundBlock,
    alignItem, getText = ({ text }) => text
}) => {
    return (
        <Container 
            align={alignItem}
            position={positionFoundBlock}>
            {dataFound.map((itemData, idx) => {
                const text = getText(itemData);
                return (
                    <li 
                        key={idx}
                        onClick={() => onClick(itemData)}
                        title={text}>
                        {text}
                    </li>
                );
            })}
        </Container>
    );
}

export default FoundBlock;